import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { of } from 'rxjs/observable/of';
import { catchError, tap } from 'rxjs/operators';

import { AutenticacaoService } from './components/autenticacao/autenticacao.service';
import { Globals } from './components/base/util/globals';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewChecked {
  title = 'app';
  msgs: any;
  displayModal = false;
  loading = false;
  timer: any;

  constructor(
    private autenticacaoService: AutenticacaoService,
    private cdRef: ChangeDetectorRef,
    private globals: Globals,
    public router: Router
  ) { }

  ngOnInit() {
    this.autenticacaoService.loginInfoObservable.pipe(
      tap(response => {
        if (response) {
          this.verifyExpiredSession();
        }
      })
    ).subscribe();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  exibeImgBackground() {
    if (this.router.url.indexOf('/get-image/') !== -1) {
      return false;
    } else {
      return true;
    }
  }

  getGlobals() {
    return this.globals;
  }

  extendSession() {
    this.loading = true;
    this.autenticacaoService.atualizarToken().pipe(
      tap(_ => {
        this.loading = false;
        this.displayModal = false;
      }),
      catchError(() => {
        this.logout();
        return of(null);
      }),
    ).subscribe();
  }

  logout() {
    this.autenticacaoService.logout();
    this.displayModal = false;
  }


  verifyExpiredSession() {
    if (this.timer) {
      clearTimeout(this.timer);
    }

    const token = this.autenticacaoService.tokenAcess;

    if (!token) {
      this.logout();
      return;
    }

    const pieceOfToken = token.split('.');
    const decryptResult = window.atob(pieceOfToken[1]);
    const tokenExp = JSON.parse(decryptResult)['exp'] * 1000;
    const timeOutToken = tokenExp - Date.now();

    this.timer = setTimeout(() => {
      if (this.autenticacaoService.isUsuarioLogado()) {
        this.displayModal = true;
      }
    }, timeOutToken);
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts